import 'focus-visible'

function common(context) {
  context.keys().forEach(context)
}

common(require.context('./modules/common/', true, /\.js$/))
